import { render, staticRenderFns } from "./CreateYourShiftsSvg.vue?vue&type=template&id=1f37f3a6&scoped=true&"
import script from "./CreateYourShiftsSvg.vue?vue&type=script&lang=ts&"
export * from "./CreateYourShiftsSvg.vue?vue&type=script&lang=ts&"
import style0 from "./CreateYourShiftsSvg.vue?vue&type=style&index=0&id=1f37f3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f37f3a6",
  null
  
)

export default component.exports